// src/components/Instances/views/Licensed/LicensedData.tsx
import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * Interfaz de cada row devuelta por /v1/ctxr/-1/list?tenantId=1
 */
interface ClusterData {
    id: number;
    name: string;
    description: string;
}

export interface LicensedInstance {
    id: string;
    name: string;
    description: string;
    license: string;
    lastupdate: string;  // p.ej "2024-07-11T19:27:17.000Z"
    Suscription: string;
    activated: string;   // p.ej "2024-07-02T03:54:37.000Z"
    cluster: ClusterData | null;
    localpref: number | null;
}

/**
 * Columnas que se mostrarán en la tabla Licensed Instances:
 * - Name
 * - Description
 * - License
 * - ID
 * - High Availability (cluster.name u "Off")
 * - Actions (edit/delete/release)
 */
export const columns: GenericTableColumn<LicensedInstance>[] = [
    {
        header: "Name",
        accessor: "name",
    },
    {
        header: "Description",
        accessor: "description",
    },
    {
        header: "License",
        accessor: "license",
    },
    {
        header: "ID",
        accessor: "id",
    },
    {
        header: "High Availability",
        accessor: "id",
        renderCell: (row) => (row.cluster ? row.cluster.name : "Off"),
    },
    {
        header: "Actions",
        // accessor es requerido por la interfaz,
        // lo “pisaremos” en LicensedPage con renderCell
        accessor: "id",
        renderCell: () => <div>Will be overridden in LicensedPage</div>,
    },
];
